/** HTTP/ISAPI access only; streaming/transcoding ports are separate settings. */
export function nvrHttpUrl(hostname: string, httpPort?: string | number | null, legacyPort?: string | number | null): string {
  let value = hostname.trim();
  if (!value || /\s/.test(value)) throw new Error('Enter an NVR hostname without spaces.');
  if (!value.includes('://')) {
    if ((value.match(/:/g) || []).length > 1 && !value.startsWith('[')) value = `[${value}]`;
    value = `http://${value}`;
  }
  let address: URL;
  try { address = new URL(value); }
  catch { throw new Error('Enter a valid NVR hostname or HTTP/HTTPS address with an optional port.'); }
  if (!['http:', 'https:'].includes(address.protocol) || address.username || address.password
    || address.pathname !== '/' || address.search || address.hash || value.includes('\\')) {
    throw new Error('Use an HTTP/HTTPS NVR hostname without credentials or a path.');
  }
  const authority = value.split('://')[1].split('/')[0];
  if (authority.endsWith(':')) throw new Error('Enter a valid NVR HTTP/ISAPI port.');
  // URL.port omits explicit default ports, so retain an inline :80/:443 too.
  const inlinePort = authority.match(/:(\d+)$/)?.[1];
  const selected = inlinePort ?? (httpPort === '' ? undefined : httpPort)
    ?? (legacyPort === '' ? undefined : legacyPort) ?? (address.protocol === 'https:' ? 443 : 80);
  if (!/^\d+$/.test(String(selected)) || Number(selected) < 1 || Number(selected) > 65535) {
    throw new Error('NVR HTTP/ISAPI port must be a whole number from 1 to 65535.');
  }
  return `${address.protocol}//${address.hostname}:${Number(selected)}`;
}
